import { FloatingDialog } from "../atoms/FloatingDialog";
import { iconNotas } from "../../../src/helpers/ImagesCache";
import useTranslation from "../../hooks/useTranslation";
import SimpleButton from "../NSButton/Types/SimpleButton";

const DialogSureToDelete = ({ visible, onClose, onConfirm }) => {
  const T = useTranslation();
  return (
    <FloatingDialog isOpen={visible} onClose={onClose}>
      <div className="flex flex-col w-full h-full items-center justify-center gap-5">
        <img src={iconNotas} />
        <span className="font-bold text-center text-base  text-[24px]">
          {T("sureToDelete")}
        </span>
        <div className="flex flex-wrap justify-center gap-4 w-full max-w-[450px]">
          <SimpleButton onClick={onConfirm} text={T("Borrar informe")} variant="gray" />
          <SimpleButton onClick={onClose} text={T("Cancelar")} />
        </div>
      </div>
    </FloatingDialog>
  );
};

export default DialogSureToDelete;
